import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

export default function useLocationsTabs(id: string, spacesEnabled: boolean) {
  const { navigation } = useNavigation()

  const defaultLocationsTabs = [
    {
      id: 'details',
      label: i18n.t('settings.locations.tabs.details'),
      href: navigation.settings.locations.locationsId.details.fullPath({ id }),
    },
    {
      id: 'employees',
      label: i18n.t('settings.locations.tabs.employees'),
      href: navigation.settings.locations.locationsId.employees.fullPath({ id }),
    },
    {
      id: 'holidays',
      label: i18n.t('settings.locations.tabs.holidays'),
      href: navigation.settings.locations.locationsId.holidays.fullPath({ id }),
    },
  ]

  const workAreaTab = {
    id: 'work_areas',
    label: i18n.t('settings.locations.tabs.work_areas'),
    href: navigation.settings.locations.locationsId.workAreas.fullPath({ id }),
  }

  return hasFeature('dev_location_work_areas') || spacesEnabled
    ? [...defaultLocationsTabs, workAreaTab]
    : defaultLocationsTabs
}
